import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';

/**
 * Function to fetch product details.
 * pp5007750843
 * pp5006370263
 * pp5009600060
 * 16c3957 - promotional
 */
export const getProductDetails = (payload, { virtualAPI }) => { //eslint-disable-line
    const context = RestClient.getContext();
    let apiHost;
    /* istanbul ignore next */
    if (__SERVER__) {
        apiHost = apiHosts.elb;
    } else {
        apiHost = apiHosts.browse;
    }
    const queryParams = {
        regionId: 'high',
    };

    /* istanbul ignore next */
    const getDetails = (json) => {
        const productDetails = json;

        if (!productDetails.data) {
            productDetails.data = {};
        }

        productDetails.data.status = json.status;
        if (__SERVER__) {
            productDetails.data.CacheControl =
                json &&
                json.headers &&
                json.headers._headers &&
                json.headers._headers['cache-control'];
        }

        return productDetails;
    };

    const aggregatorVersion = 'v2';

    const config = {
        apiHost,
        excludeVersion: true,
        credentials: 'include',
        url: `/${aggregatorVersion}/product-aggregator/${payload.ppid}`,
        virtual: virtualAPI,
        params: queryParams,
        hostname: context && context.hostname, // this is needed to have proper specifications url returned back on lower environments
        XForwardedChannelHeader: `${payload.deviceSize}`,
        XForwardedChannelHeaderHost: payload.forwardedChannelHeaderHost
            ? payload.forwardedChannelHeaderHost
            : null,
        version: 1,
        requestHeaderCookie: true,
    };
    /* istanbul ignore next */
    return RestClient.get(config)
        .then((json) => getDetails(json))
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};
